import { render, staticRenderFns } from "./TestTable.vue?vue&type=template&id=24102b2b&scoped=true&"
import script from "./TestTable.vue?vue&type=script&lang=js&"
export * from "./TestTable.vue?vue&type=script&lang=js&"
import style0 from "./TestTable.vue?vue&type=style&index=0&id=24102b2b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24102b2b",
  null
  
)

export default component.exports